import { useTranslation } from "react-i18next";

export const useGetClassColumnDefs = (isDraft: boolean) =>{
	const { t } = useTranslation();
	return [
	{
		cellRenderer: "sortingCellRenderers",
		cellRendererParams: {
			isDraft: isDraft,
		},
		field: "action",
		headerName: "",
		flex: 1,
		sortable: false,
		minWidth: 128,
	},
	{
		cellRenderer: "nameCellRenderers",
		field: "name",
		headerName: t("pages.configuration.scheme.classColumnDetails.column1"),
		flex: 1,
		sortable: false,
		cellClass:"text-bold-underline"
	},
	{
		field: "ruleCount",
		headerName: t("pages.configuration.scheme.classColumnDetails.column2"),
		width: 200,
		sortable: false,
	},
	{
		field: "isDefault",
		headerName: t("pages.configuration.scheme.classColumnDetails.column3"),
		width: 200,
		sortable: false,
		cellRenderer: "agCheckboxCellRenderer",
	},
	{
		field: "description",
		flex: 1,
		sortable: false,
		headerName: t("pages.configuration.scheme.classColumnDetails.column4"),
	},
	{
		cellRenderer: "ruleLinkCellRenderers",
		field: "action",
		headerName: "",
		flex: 1,
		sortable: false,
		hide: !isDraft,
	},
	{
		cellRenderer: "actionCellRenderers",
		field: "action",
		headerName: "",
		flex: 1,
		sortable: false,
		hide: !isDraft,
		cellClass: "align-right",
	},
]};
